import Vue from "vue";
import Router from "vue-router";
import Meta from 'vue-meta'

import Home from "./views/Home";
import Properties from "./views/Properties";
import Property from "./views/Property";

Vue.use(Router);
Vue.use(Meta)

function checkUser(goTo) {
  if (localStorage.getItem("AUTH_TOKEN")) {
    goTo();
  } else {
    goTo({ name: "sign_in", replace: true });
  }
}

const router = new Router({
  mode: "history",
  base: "/homes",
  routes: [
    {
      path: "/blog",
      name: "blog",
      beforeEnter() {
        window.location = "/"
      }
    },
    {
      path: "/cma",
      name: "cma",
      beforeEnter() {
        window.location = "/free-home-valuation/"
      }
    },
    {
      path: "/articles",
      name: "articles",
      beforeEnter() {
        window.location = "/articles"
      }
    },
    {
      path: "/lifestyle-quiz",
      name: "home",
      component: Home
    },
    {
      path: "/",
      name: "properties",
      component: Properties,
    },
    {
      path: "/property/:fullAddress/:id",
      name: "property",
      component: Property,
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/PrivacyPolicy"
        )
    },
    {
      path: "/terms_of_use",
      name: "terms_of_use",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/TermsOfUse"
        )
    },
    {
      path: "/agentstos",
      name: "agentstos",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/AgentsTerms"
        )
    },
    {
      path: "/about_us",
      name: "about_us",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/AboutUs"
        )
    },
    {
      path: "/faq",
      name: "faq",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/FAQ/FAQMain"
        )
    },
    {
      path: "/faq/search",
      name: "faq_search",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/FAQ/FAQSearch"
        )
    },
    {
      path: "/faq/:id",
      name: "faq_topic",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/FAQ/FAQTopic"
        )
    },
    {
      path: "/faq/:id/details/:topicId",
      name: "faq_details",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/FAQ/FAQDetails"
        )
    },
    {
      path: "/agents",
      name: "agents",
      beforeEnter() {
        window.location = "/careers"
      },
    },
    {
      path: "/homeowners",
      name: "home_owners",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/HomeOwners/"
        )
    },
    {
      path: "/sellers",
      beforeEnter() {
        window.location = "/blog/sell-your-home-with-anycurb/"
      }
    },
    {
      path: "/contact_us",
      name: "contact_us",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/ContactUs/"
        ),
      props: true
    },
    {
      path: "/404",
      name: "404",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/NotFound/"
        )
    },
    {
      path: "/500",
      name: "500",
      component: () =>
        import(
          /* webpackChunkName: "static_pages" */ "./views/static_pages/InternalServerError/"
        )
    },
    {
      path: "*",
      redirect: "/404"
    },
    // AUTH
    {
      path: "/sign_up/role",
      name: "sign_up_role",
      component: () =>
        import(/* webpackChunkName: "auth_pages" */ "./views/auth/Role"),
      meta: {
        layout: "auth-layout"
      }
    },
    {
      path: "/sign_up/agent_info",
      name: "sign_up_agent_info",
      component: () =>
        import(/* webpackChunkName: "auth_pages" */ "./views/auth/AgentInfo"),
      meta: {
        layout: "auth-layout"
      }
    },
    {
      path: "/sign_up",
      name: "sign_up",
      component: () =>
        import(/* webpackChunkName: "auth_pages" */ "./views/auth/SignUp"),
      meta: {
        layout: "auth-layout"
      }
    },
    {
      path: "/sign_up/identity_documents",
      name: "identity_documents",
      component: () =>
        import(
          /* webpackChunkName: "auth_pages" */ "./views/auth/IdentityDocuments"
        ),
      meta: {
        layout: "auth-layout"
      }
    },
    {
      path: "/users/confirmation_email",
      name: "confirmation_email",
      component: () =>
        import(
          /* webpackChunkName: "auth_pages" */ "./views/auth/ConfirmationEmail"
        ),
      meta: {
        layout: "auth-layout"
      },
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("AUTH_TOKEN")) {
          next({ name: "home" });
        } else {
          next();
        }
      }
    },
    {
      path: "/users/confirmation_phone",
      name: "confirmation_phone",
      component: () =>
        import(
          /* webpackChunkName: "auth_pages" */ "./views/auth/ConfirmationPhone"
        ),
      meta: {
        layout: "auth-layout"
      },
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("AUTH_TOKEN")) {
          next({ name: "home" });
        } else {
          next();
        }
      },

      props: { type: "sing_up" }
    },
    {
      path: "/users/reset_password_confirmation",
      name: "reset_password_confirmation",
      component: () =>
        import(
          /* webpackChunkName: "auth_pages" */ "./views/auth/ConfirmationPhone"
        ),
      meta: {
        layout: "auth-layout"
      },
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("AUTH_TOKEN")) {
          next({ name: "home" });
        } else {
          next();
        }
      },

      props: { type: "reset_password" }
    },
    {
      path: "/personalize",
      name: "personalize",
      component: () =>
        import(/* webpackChunkName: "auth_pages" */ "./views/auth/Personalize"),
      meta: {
        layout: "auth-layout"
      }
    },
    {
      path: "/sign_in",
      name: "sign_in",
      component: () =>
        import(/* webpackChunkName: "auth_pages" */ "./views/auth/SignIn"),
      meta: {
        layout: "auth-layout"
      }
    },
    {
      path: "/forgot_password",
      name: "forgot_password",
      component: () =>
        import(
          /* webpackChunkName: "auth_pages" */ "./views/auth/ForgotPassword"
        ),
      meta: {
        layout: "auth-layout"
      },
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("AUTH_TOKEN")) {
          next({ name: "home" });
        } else {
          next();
        }
      }
    },
    {
      path: "/users/password/edit",
      name: "reset_password",
      component: () =>
        import(
          /* webpackChunkName: "auth_pages" */ "./views/auth/ResetPassword"
        ),
      meta: {
        layout: "auth-layout"
      },
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("AUTH_TOKEN")) {
          next({ name: "home" });
        } else {
          next();
        }
      },

      props: true
    },

    // AGENT PUBLIC PAGE
    {
      path: "/agent/:id",
      name: "public_agent_profile",
      component: () =>
        import(
          /* webpackChunkName: "public_profile" */ "./views/agent/PublicProfile"
        )
    },

    // AGENT PROFILE
    {
      path: "/agent/profile",
      component: () =>
        import(/* webpackChunkName: "agent_profile" */ "./views/agent/Profile"),

      beforeEnter: (to, from, next) => {
        // if (Store.state.user.role === "agent") {
        if (localStorage.getItem("AUTH_TOKEN")) {
          next();
        } else {
          next({ name: "sign_in", replace: true });
        }
      },

      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "agent_profile" */ "./views/agent/Info")
        },
        {
          path: "info",
          name: "agent_profile_info",
          component: () =>
            import(/* webpackChunkName: "agent_profile" */ "./views/agent/Info")
        }
      ]
    },

    // CHAT

    {
      path: "/messages",
      name: "messages",
      component: () =>
        import(/* webpackChunkName: "agent_profile" */ "./views/Messages"),

      beforeEnter: (to, from, next) => {
        checkUser(next);
      }
    },

    // BUYER PUBLIC PAGE
    {
      path: "/user/:id",
      name: "public_user_profile",
      component: () =>
        import(
          /* webpackChunkName: "public_profile" */ "./views/user/PublicProfile"
        )
    },

    // BUYER PROFILE
    {
      path: "/user/profile",
      component: () =>
        import(/* webpackChunkName: "buyer_profile" */ "./views/user/Profile"),

      children: [
        {
          path: "",
          component: () =>
            import(/* webpackChunkName: "buyer_profile" */ "./views/user/Info")
        },
        {
          path: "info",
          name: "user_profile_info",
          component: () =>
            import(/* webpackChunkName: "buyer_profile" */ "./views/user/Info")
        }
      ]
    }
  ],

  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.afterEach(() => {
  window.Intercom && window.Intercom("update");
});

export default router;
